import { NotificationType, PartialToast, ShToastFactory, Toast } from '@stylehaven/components';

import { MeldingState } from './export-melding.helper';

export const DOWNLOADS_ROUTE: string = '/downloads';

export function busyMelding(toastFactory: ShToastFactory, message: string): Toast {
    return toastFactory.create({
        message,
        type: NotificationType.Update,
        icon: 'spinner',
        iconRotate: true,
        autoClose: false,
        closable: true
    });
}

export function meldingToast(state: MeldingState, message: string, linkText: string): PartialToast {
    return {
        message,
        type: state.kind === 'success' ? NotificationType.Success : NotificationType.Error,
        icon: state.kind === 'success' ? 'thumbs-up' : 'delete',
        iconRotate: false,
        autoClose: false,
        closable: true,
        ...(state.withLink && { navigationLink: { route: DOWNLOADS_ROUTE }, linkText })
    };
}

export function busyMeldingUpdate(message: string): PartialToast {
    return {
        message,
        type: NotificationType.Update,
        icon: 'spinner',
        iconRotate: true,
        autoClose: false,
        closable: true
    };
}

export function followUpMelding(message: string, linkText: string): PartialToast {
    return {
        message,
        type: NotificationType.Warning,
        icon: 'warning',
        iconRotate: false,
        autoClose: false,
        closable: true,
        navigationLink: { route: DOWNLOADS_ROUTE },
        linkText
    };
}

export function failureMelding(message: string): PartialToast {
    return {
        message,
        type: NotificationType.Error,
        icon: 'delete',
        iconRotate: false,
        autoClose: true,
        closable: true
    };
}

export function failureMeldingToast(toastFactory: ShToastFactory, message: string): Toast {
    return toastFactory.create(failureMelding(message));
}

export function reportBusyMelding(toastFactory: ShToastFactory, message: string): Toast {
    return toastFactory.create({
        message,
        type: NotificationType.Update,
        icon: 'spinner',
        iconRotate: true,
        autoClose: false,
        closable: true
    });
}

export function reportRejectionsMelding(message: string): PartialToast {
    return {
        message,
        type: NotificationType.Warning,
        icon: 'warning',
        iconRotate: false,
        autoClose: false,
        closable: true
    };
}

export function reportNoneMelding(message: string): PartialToast {
    return {
        message,
        type: NotificationType.Success,
        icon: 'thumbs-up',
        iconRotate: false,
        autoClose: true,
        closable: true
    };
}

export function reportNoPermissionMelding(toastFactory: ShToastFactory, message: string): Toast {
    return toastFactory.create({
        message,
        type: NotificationType.Update,
        icon: 'info',
        iconRotate: false,
        autoClose: true,
        closable: true
    });
}

export function reportFailureMelding(message: string): PartialToast {
    return {
        message,
        type: NotificationType.Error,
        icon: 'delete',
        iconRotate: false,
        autoClose: false,
        closable: true
    };
}
